import { useMalware } from "../../context/Dashboard/contextMalware";
import { useDesign } from "../../context/contextDesign";
import ScanCard from "../../layouts/malware/ScanCard";
import ScanView from "../../layouts/malware/ScanView";
import GraphView from "../../layouts/malware/GraphView";
import Loader2 from "../../components/loaders/Loader-2";

const MalwareScanner = () => {
  const { zoom, bHeightVal } = useDesign();
  const { activeView, setActiveView, malAssets, malScanLoading } = useMalware();

  const renderCurrentState = () => {
    if (malScanLoading) return (
      <div className="container-fluid"
        style={{ height: `calc(${bHeightVal} - 200px)` }}>
        <Loader2 />
      </div>
    );
    switch (activeView) {
      case "GRAPH":
        return <GraphView />;
      case "VIEW":
        return <ScanView />;
      case "CARD":
      default:
        return <ScanCard />;
    }
  };

  const getButtonProps = () => {
    if (activeView === "GRAPH") return { label: "NEW SCAN", icon: "plus-lg", target: "CARD" };
    if (activeView === "VIEW") return { label: "VIEW HISTORY", icon: "clock-history", target: "GRAPH" };
    return { label: "VIEW HISTORY", icon: "bar-chart-fill", target: "GRAPH" };
  };

  const btn = getButtonProps();

  return (
    <div className="malware-dashboard position-relative overflow-y-auto pb-5" style={{ zoom: zoom }}>
      {malAssets?.length > 0 && !malScanLoading && (
        <div className="position-absolute top-0 end-0 p-3 py-0">
          <button
            className="btn shadow-sm d-flex align-items-center gap-2 border-0"
            style={{
              backgroundColor: activeView === "GRAPH" ? "#1d1d1d" : "#344266",
              color: "#fff",
              borderRadius: "10px",
              padding: "10px 24px"
            }}
            onClick={() => setActiveView(btn.target)}
          >
            <i className={`bi bi-${btn.icon}`}></i>
            <span className="fw-bold small">{btn.label}</span>
          </button>
        </div>
      )}

      <div className="container-fluid h-100">
        <div className="row h-100 align-items-center justify-content-center">
          <div className="col-12">
            {renderCurrentState()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MalwareScanner;
